import { createAsyncThunk } from "@reduxjs/toolkit";
import { setExplainWithAiNewDataNeeded } from "@/store/explain-with-ai/explainWithAiSlice";
import { setExplainWithAiDataByWidgetIdFromDashboardThunk } from "@/store/dashboards/thunks/widgets/common/setExplainWithAiDataByWidgetIdFromDashboardThunk";

export const updateExplainWithAiSliceBuWidgetIdThunk = createAsyncThunk(
  "explainWithAi/updateExplainWithAiSliceBuWidgetId",
  (widgetId: string, { dispatch }) => {
    dispatch(setExplainWithAiNewDataNeeded(true));
    dispatch(setExplainWithAiDataByWidgetIdFromDashboardThunk(widgetId));
  },
);
